import { useEffect } from 'react';
import PageHeader from '../../components/PageHeader';
import { Icon } from '../../components/Icons';
import { RESEARCH_LLM } from '../../config/data';
import { t } from '../../utils/i18n';
import './index.css';

export default function ResearchAgentPage() {
    const left = RESEARCH_LLM?.leftInfo ?? {};
    const features = RESEARCH_LLM?.rightList ?? [];

    useEffect(() => {
        document.title = t('大模型 · 至知创新研究院', 'Large Models · IQuest Research');
    }, []);

    return (
        <div className="page-shell">
            <PageHeader
                className="page-header-largemodel"
                eyebrow={t('大模型 · Large Models', 'Large Models')}
                title={t('高性能、易部署、强执行、强推理的大模型体系', <>High-Performance, Easy-to-Deploy,<br/>Strong-Reasoning LLM System<br/>with Robust Task Execution</>)}
                subtitle={t(
                    '融合软件工程、工具调用与复杂任务执行能力，面向真实开发场景。',
                    'Integrating software engineering, tool use, and complex task execution capabilities for real-world development scenarios.'
                )}
            />
            <section className="section research-detail-section">
                <div className="container research-split">
                    <div className="research-split-left">
                        <div className="research-split-card">
                            <div className="research-split-img">
                                {left?.img && <img src={left.img} alt={left?.title} loading="lazy" decoding="async" />}
                            </div>
                            <div className="research-split-card-body">
                                <div className="research-split-card-title">{left?.title}</div>
                                <p className="research-split-card-desc">{left?.desc}</p>
                                {left?.href && (
                                    <div className="research-split-card-actions">
                                        <a
                                            className="btn btn-secondary project-link"
                                            href={left.href}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {t('访问项目', 'Learn More')}
                                            <Icon name="arrowRight" width={16} height={16} aria-hidden />
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="research-split-right">
                        {features.map((feature, idx) => (
                            <div className="research-feature-item" key={feature.id ?? idx}>
                                <div className="research-feature-icon">
                                    {feature.iconName
                                        ? <Icon name={feature.iconName} width={20} height={20} />
                                        : <span>{idx + 1}</span>}
                                </div>
                                <div className="research-feature-body">
                                    <div className="research-feature-title">{feature.title}</div>
                                    <p className="research-feature-desc">{feature.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
